import { X, Activity, Loader2 } from 'lucide-react'
import { Button, ScrollArea } from '@/components/ui'
import { ActivityEntry } from './ActivityEntry'
import { useAgentActivity } from '@/hooks/useAgentActivity'
import { useUiStore } from '@/stores/uiStore'

export function ActivityFeed() {
  const { activityPanelOpen, setActivityPanelOpen } = useUiStore()
  const { data, isLoading } = useAgentActivity()

  if (!activityPanelOpen) return null

  const items = data?.items ?? []

  // Group by day
  const today = new Date().toDateString()
  const todayItems = items.filter((i) => new Date(i.timestamp).toDateString() === today)
  const olderItems = items.filter((i) => new Date(i.timestamp).toDateString() !== today)

  return (
    <>
      {/* Backdrop (mobile) */}
      <div
        className="fixed inset-0 bg-black/50 z-40 lg:hidden"
        onClick={() => setActivityPanelOpen(false)}
      />

      {/* Panel */}
      <div className="fixed right-0 top-14 bottom-0 z-40 w-80 bg-sidebar border-l border-primary/15 shadow-[-4px_0_16px_-4px_hsl(var(--primary)/0.06)] flex flex-col animate-in slide-in-from-right duration-200">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b">
          <div className="flex items-center gap-2">
            <Activity className="h-4 w-4 text-primary" />
            <h2 className="font-semibold text-sm">Agent Activity</h2>
          </div>
          <Button
            variant="ghost"
            size="icon"
            className="h-7 w-7"
            onClick={() => setActivityPanelOpen(false)}
          >
            <X className="h-4 w-4" />
          </Button>
        </div>

        {/* Content */}
        <ScrollArea className="flex-1">
          {isLoading ? (
            <div className="flex items-center justify-center py-12">
              <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" />
            </div>
          ) : items.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-12 text-center px-4">
              <Activity className="h-10 w-10 text-muted-foreground/30 mb-3" />
              <p className="text-sm text-muted-foreground">No agent activity yet</p>
              <p className="text-xs text-muted-foreground mt-1">
                Activity will appear here as the agent works on your behalf.
              </p>
            </div>
          ) : (
            <div className="p-2">
              {todayItems.length > 0 && (
                <div>
                  <p className="text-xs font-medium text-muted-foreground px-3 py-2">
                    Today &mdash; {todayItems.length} actions
                  </p>
                  {todayItems.map((item) => (
                    <ActivityEntry key={item.id} item={item} />
                  ))}
                </div>
              )}
              {olderItems.length > 0 && (
                <div>
                  <p className="text-xs font-medium text-muted-foreground px-3 py-2 mt-2">
                    Earlier
                  </p>
                  {olderItems.map((item) => (
                    <ActivityEntry key={item.id} item={item} />
                  ))}
                </div>
              )}
            </div>
          )}
        </ScrollArea>
      </div>
    </>
  )
}
